import React,{ useState,useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardImg, CardText, CardBody,CardHeader,
  CardTitle, CardSubtitle } from 'reactstrap';
  import { Form} from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import sign from '../../../images/sb-images/sage sig.webp';
import fruit from '../../../images/sb-images/fruit.webp';
import puri from '../../../images/sb-images/puri.webp';
import axios from "axios";
import { var_api } from "../../constant";
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as XLSX from 'xlsx';
import { TabContent, TabPane,  NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import Nav from 'react-bootstrap/Nav';
import Swal from "sweetalert2";


const CustomerDetails = () => {
    const [modal, setModal] = useState(false);
    const history = useHistory();
    const [isLogin, setIsLogin] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Adjust number of rows per page
    const [currentPagebd, setCurrentPagebd] = useState(1);
    const [itemsPerPagebd] = useState(10);
    const [allCustomerDetails, setAllCustomerDetails] = useState([]);
    const [customerdetail, setcustomerdetail] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showBirthdayDetails, setShowBirthdayDetails] = useState(false); // State to toggle birthday details
    const [BirthdayDetails, setBirthdayDetails] = useState([]);
    const [activeTab, setActiveTab] = useState('1');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [updatedCustomer, setUpdatedCustomer] = useState(null);
    const [customerName, setCustomerName] = useState('');
    const [dob, setDob] = useState('');
    const [gender, setGender] = useState('');  // Initialize gender state
    const [email, setEmail] = useState('');    // Initialize email state
    

    const getFormattedDate = () => {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const dd = String(today.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}`;
  };
  const [selectedDate, setSelectedDate] = useState(getFormattedDate());

    const handleToggleBirthdayDetails = () => {
      setShowBirthdayDetails(!showBirthdayDetails); // Toggle birthday details display
  };

    
   const toggle = () => setModal(!modal);

 //open the view details
   const handleViewHistory = async (customer) => {
    console.log("custde",customer);
    const token = localStorage.getItem("token");
    setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/customer-details/view-service-history/${customer.customer_mobile}`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      const customerDetails = response.data.services;
      // setEmployee(response.data);
      if (customerDetails.length > 0) {
        setSelectedCustomer(customerDetails);
      } else {
          console.log('No data found.');
          setSelectedCustomer([]);
      }
      setIsLogin(false);
  } catch (error) {
      if (error.response && error.response.status === 401) {
          history.push('/signin');
      }
  }
  finally{
    setIsLogin(false);
  }
    toggle();
  };

  const convertTo12HourFormat = (time) => {
    const [hour, minute] = time.split(':');
    let hours = parseInt(hour);
    const minutes = parseInt(minute);
  
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12 for midnight
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  
    return `${hours}:${formattedMinutes} ${ampm}`;
  };
  const convertMinutesToHours = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h ${remainingMinutes}m`;
  };
  
  const ServiceComponent = ({ innerService }) => {
    return (
      <div>
                {/* <h6 style={{ fontWeight: 'bold' }}>{convertMinutesToHours(innerService.service_duration)} </h6> */}

        <h6 style={{ fontWeight: 'bold' }}>Start Time:{innerService.start_time ? convertTo12HourFormat(innerService.start_time) : "-"} </h6>
        <h6 style={{ fontWeight: 'bold' }}>End Time: {innerService.end_time ? convertTo12HourFormat(innerService.end_time) : "-"} </h6>
      </div>
    );
  };
  
  



   useEffect(() => {
    fetchcustomerdetails();
    fetchcustomerBDdetails();
}, []);


const fetchcustomerdetails = async () => {
    const token = localStorage.getItem('token');
  
    setIsLogin(true);
    try {
        const response = await axios.get(`${var_api}/api/get-customer-details`, {
            headers: {
                'Authorization': `${token}`
            }
        });
        const customerDetails = response.data.customers;
        if (customerDetails && Array.isArray(customerDetails)) {
        setAllCustomerDetails(customerDetails); // Store all customer details
         } else {
        console.log('No data found or invalid data format.');
        setAllCustomerDetails([])
        setcustomerdetail([]);
        // setTotalItems(0);
        // setStartIndex(0); // Reset startIndex state variable
    }
        setIsLogin(false);
    } catch (error) {
        if (error.response && error.response.status === 401) {
            history.push('/signin');
        }
    }
    finally{
      setIsLogin(false);
    }
};



const fetchcustomerBDdetails = async () => {
  const token = localStorage.getItem('token');
//   const startIndexCalcbd = (currentPagebd - 1) * itemsPerPagebd;
// const endIndexbd = startIndexCalcbd + itemsPerPagebd;
  setIsLogin(true);
  const date = formatDate(selectedDate)
  try {
      const response = await axios.get(`${var_api}/api/customer-birthday-details/${date}`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      const customerDetails = response.data;
      // setEmployee(response.data);
      if (customerDetails.length > 0) {
          setBirthdayDetails(customerDetails);
          
      } else {
          console.log('No data found.');
          setBirthdayDetails([]);
      }
      setIsLogin(false);
  } catch (error) {
      if (error.response && error.response.status === 401) {
          history.push('/signin');
      }
  }
};



    //Navigate to home page
    const handleGoTOHome = () => {
        history.push('/sb-home');
    };

    const formatDate = (dateString) => {
      const [year, month] = dateString.split('-');  // Input format 'YYYY-MM'
      const day = '15';  // Add day '15' as required
      return `${day}-${month}-${year}`;  // Return 'dd-mm-yyyy' format
    };
    

    useEffect(() => {
      if (selectedDate) {
          fetchcustomerBDdetails();
      }
  }, [selectedDate]);


  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  
}

    

const handleDateHistoryChange = (event) => {
  const newDate = event.target.value;  // This will be in 'YYYY-MM' format
  console.log("Selected Month:", newDate);  // Logs 'YYYY-MM'

  // Set the 15th day of the selected month and year
  const formattedDateForAPI = `${newDate}-15`;  // 'YYYY-MM-15'
  console.log("Date for API:", formattedDateForAPI);

  setSelectedDate(newDate);  // Keep the selected month and year in the state
};



    const downloadExcel = () => {
      // Prepare data in a format compatible with xlsx
      const data = BirthdayDetails.map((customer, index) => ({
        'S.No': index + 1,
        'Name': customer.customer_name,
        'Mobile': customer.customer_mobile,
        'DOB': customer.dob,
        'Gender':customer.gender || "-",
        'Email': customer.email || "-"
      }));
    
      // Create a new workbook
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(data);
    
      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'BirthdayDetails');
    
      // Generate XLSX file and download it
      XLSX.writeFile(workbook, `BirthdayDetails${selectedDate}.xlsx`);
    };


    function formatTimeTo12Hours(timeString) {
      if (!timeString) return '';
      const [hours, minutes] = timeString.split(':');
      let period = 'AM';
      let hour = parseInt(hours, 10);
    
      if (hour === 0) {
        hour = 12;
      } else if (hour === 12) {
        period = 'PM';
      } else if (hour > 12) {
        hour -= 12;
        period = 'PM';
      }
    
      return `${hour}:${minutes} ${period}`;
    }


const handleEditCustomer = (customer) => {
  setUpdatedCustomer(customer);
  setCustomerName(customer.customer_name);
  setDob(formatDateForInput(customer.dob)); // Format for input field
  setEmail(customer.email || '-');
  setGender(customer.gender || '');
  setIsModalOpen(true);
  console.log('abc',customer.gender);
};



// Function to format date to dd-mm-yyyy
const formatDateForApi = (date) => {
  if (!date) return '';
  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
};


 // Function to handle form submission
 const handleUpdateCustomer = async () => {
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `${token}`,
  };
  setIsLogin(true);

  try {
    await axios.put(`${var_api}/api/customer-details/put/${updatedCustomer.id}`, {
      customer_name: customerName,
      dob: formatDateForApi(dob),
      email: email,          // Include email
      gender: gender,        // Include gender
    }, { headers });

    // Handle successful update, e.g., show a success message, refresh data, etc.
    Swal.fire({
      icon: 'success',
      title: 'Customer details updated successfully!',
      text: 'The customer details have been updated.',
      confirmButtonColor: '#007500',
    });
    setIsModalOpen(false);
    setIsLogin(false);
    fetchcustomerdetails();
  } catch (error) {
    console.error('Error updating customer details:', error);
    // Handle error, e.g., show an error message
  }
};

const capitalizeFirstLetter = (string) => {
  if (!string) return ""; // Return empty string if input is falsy
  return string.charAt(0).toUpperCase() + string.slice(1);
};


const getStatusText = (status) => {
  switch (status) {
    case 0:
      return 'Upcoming';
    case 1:
      return 'Inprogress';
    case 2:
      return 'Completed';
    default:
      return 'Cancel';
  }
};

const getStatusColor = (status) => {
  switch (status) {
    case 0:
      return 'orange';  // Background color for Upcoming
    case 1:
      return 'blue';    // Background color for Inprogress
    case 2:
      return 'green';   // Background color for Completed
    default:
      return 'red';     // Background color for Cancel
  }
};

const formatDateForDisplay = (date) => {
  if (!date) return '';
  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
};

const formatDateForInput = (date) => {
  if (!date) return '';
  const [day, month, year] = date.split('-');
  return `${year}-${month}-${day}`;
};

const handleSearchChange = (e) => {
  setSearchTerm(e.target.value);
  setCurrentPage(1); // Reset to the first page
};

// Paginate filtered results for Tab 1
const filteredCustomers = allCustomerDetails.filter((customer) =>
  customer.customer_name.toLowerCase().includes(searchTerm.toLowerCase())
);
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentCustomers = filteredCustomers.slice(indexOfFirstItem, indexOfLastItem);

// Paginate for Tab 2
const indexOfLastItemBD = currentPagebd * itemsPerPagebd;
const indexOfFirstItemBD = indexOfLastItemBD - itemsPerPagebd;
const currentBirthdayDetails = BirthdayDetails.slice(indexOfFirstItemBD, indexOfLastItemBD);

const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
const handlePageChangeBD = (pageNumber) => setCurrentPagebd(pageNumber);




    return(
      <>
      {isLogin && <Loader />}
        <div  style={{ backgroundColor: "white", fontFamily:"Arial, Helvetica, sans-serif"}}>
        <nav className="navbar  navbar-light py-2 sticky-top" style={{boxShadow: "0px 0px 1px 0px black",backgroundColor:"rgba(103, 120, 95)",border:"none",padding:"10px"}} >
            <h3 style={{textAlign:"center",color:"white"}} id="kifo"><i class="bi bi-person-fill-gear"></i>{" "}CUSTOMER DETAILS</h3>
            <button className="btn" style={{color:"rgba(103, 120, 95)", backgroundColor:"white"}} onClick={handleGoTOHome}><i class="bi bi-house"></i> Go to home</button>
        </nav>
        <br/>
        <div className="d-flex justify-content-center mt-3">
      <Nav tabs>
        <NavItem style={{ border: "1px solid black", borderRadius: "8px", marginRight: "10px" }}>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { toggleTab('1'); }}
            style={{ backgroundColor: activeTab === '1' ? 'rgba(50, 103, 19, 0.305)' : 'transparent', color: activeTab === '1' ? 'white' : 'black' }}
          >
            Customer's Details
          </NavLink>
        </NavItem>
        <NavItem style={{ border: "1px solid black", borderRadius: "8px", marginRight: "10px" }}>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { toggleTab('2'); }}
            style={{ backgroundColor: activeTab === '2' ? 'rgba(50, 103, 19, 0.305)' : 'transparent', color: activeTab === '2' ? 'white' : 'black' }}
          >
           Customer's Birthday
          </NavLink>
        </NavItem>
      </Nav>
    </div>
    <TabContent activeTab={activeTab}>
    <TabPane tabId="1">
        <div style={{padding:"15px"}}>
            <h6>
        <b>No.Of.Customers:</b> {allCustomerDetails.length} 
        <span style={{float:"right"}}><Form.Control type="text" placeholder="Search..."  onChange={handleSearchChange}/></span>
        {/* <button className="btn btn-info" style={{float:"right", color:"white", marginRight:"5px"}} onClick={handleToggleBirthdayDetails}>Customers Birthday</button> */}
    </h6>
    </div>

        <div className="card" style={{height:"auto",borderRadius:"20px", marginTop:"25px", maxWidth:"100%"}}>
    <div className="card-body">
    <div className="table-container" style={{ maxHeight: "530px", overflowX: 'auto', overflowY: 'scroll' }}>
                <table class="table table-hover" style={{ border: "none", borderColor: "grey", margin: "auto" ,height:"50%", fontFamily:"Arial, Helvetica, sans-serif"}}>
                    <thead>
                        <tr style={{ fontWeight: "bolder" }}>
                            <th scope="col">S.No</th>
                            <th scope="col">Name</th>
                            <th scope="col">Mobile</th>
                            <th scope="col">DOB</th>
                            <th scope="col">Email</th>
                            <th scope="col">Gender</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody class="body-half-screen">
                    {currentCustomers.length > 0 ? (
            currentCustomers.map((customer, index) => (
          <tr key={customer.id}>
          <td>{indexOfFirstItem + index + 1}</td>
            <td>{customer.customer_name}</td>
            <td>{customer.customer_mobile ? customer.customer_mobile : "-"}</td>
            <td>{customer.dob ? customer.dob : "-"}</td>
            <td>{customer.email ? customer.email : "-"}</td>
            <td>{customer.gender ? customer.gender : "-"}</td>
            <td>
              <button className="btn btn-primary" onClick={() => handleViewHistory(customer)}> 
                <i className="bi bi-eye-fill"></i>{" "}
              </button> {" "}
              <button className="btn btn-warning text-white" onClick={() => handleEditCustomer(customer)}> 
              <i class="bi bi-pencil-square"></i>
              </button>
            </td>
          </tr>
        )) ) : (
          <tr>
            <td colSpan="7" className="text-center">No data available</td>
          </tr>
        )
      }
                               
                    </tbody>
                </table>
                <br />
                <Pagination
    activePage={currentPage}
    itemsCountPerPage={itemsPerPage}
    totalItemsCount={filteredCustomers.length}
    pageRangeDisplayed={5}
    onChange={handlePageChange}
    itemClass="page-item"
    linkClass="page-link"
    innerClass="pagination justify-content-end"
    activeClass="active-pagination"
/>
            </div>
    </div>
</div>
        {/* </Col>
        {showBirthdayDetails && (
        <Col xs={12} md={6}> */}
          </TabPane>



<TabPane tabId="2">
        
        <div className="card" style={{height:"auto",borderRadius:"20px", marginTop:"25px", maxWidth:"100%"}}>
          
                                <div className="card-body">
                                  
                               
                                <div className="table-container" style={{ maxHeight: "530px", overflowX: 'auto', overflowY: 'scroll', marginTop:"10px" }}>
                                <input
  type="month"  // Change from date to month
  name="date"
  style={{ height: "35px", padding: "10px", float: "right" }}
  value={selectedDate}
  onChange={handleDateHistoryChange}
/>

    <button className="btn btn-warning" disabled={BirthdayDetails.length === 0} onClick={downloadExcel}>Download Birthday Details</button>
                               
    <br/>
                <table class="table table-hover" style={{ border: "none", borderColor: "grey", margin: "auto" ,height:"50%", fontFamily:"Arial, Helvetica, sans-serif", marginTop:"30px"}}>
                    <thead>
                        <tr style={{ fontWeight: "bolder" }}>
                            <th scope="col">S.No</th>
                            <th scope="col">Name</th>
                            <th scope="col">Mobile</th>
                            <th scope="col">DOB</th>
                            <th scope="col">Email</th>
                            <th scope="col">Gender</th>
                        </tr>
                    </thead>
                    <tbody class="body-half-screen">
                    {currentBirthdayDetails.length > 0 ? (
                    currentBirthdayDetails.map((customer, index) => (
          <tr key={index}>
             <td>{indexOfFirstItemBD + index + 1}</td>
            <td>{customer.customer_name}</td>
            <td>{customer.customer_mobile}</td>
            <td>{customer.dob}</td>
            <td>{customer.email}</td>
            <td>{customer.gender}</td>
          </tr>
        )) ) : (
          <tr>
            <td colSpan="6" className="text-center">No data available</td>
          </tr>
        )
      }
                               
                    </tbody>
                </table>
                <br />
                <Pagination
    activePage={currentPagebd}
    itemsCountPerPage={itemsPerPagebd}
    totalItemsCount={BirthdayDetails.length}
    pageRangeDisplayed={5}
    onChange={handlePageChangeBD}
    itemClass="page-item"
    linkClass="page-link"
    innerClass="pagination justify-content-end"
    activeClass="active-pagination"
/>
            </div>
                                </div>
                            </div>
        {/* </Col>
      )}
      </Row> */}

</TabPane>
      </TabContent>

        {selectedCustomer && (
        <Modal isOpen={modal} toggle={toggle} size="lg">
          <ModalHeader toggle={toggle}>Service History</ModalHeader>
          <ModalBody>
            <h6><b>Booking count :</b> {selectedCustomer.length}</h6>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              {selectedCustomer.map((service, index) => (
                <Card
                  bg="light"
                  key={service.id}
                  text="dark"
                  style={{ maxWidth: "28rem", height: "auto", border: "1px solid rgba(103, 120, 95)", borderRadius: "10px", marginTop: "10px", padding: "20px" }}
                  className="mb-2"
                >
                  <h6>
                    <b style={{ color: "rgba(103, 120, 95)" }}>Date:</b> {service.order_date} 
                    <span style={{ float: "right" }}>
                      <b style={{ color: "rgba(103, 120, 95)" }}>Time</b>:{service.services[0]  && service.services[0].start_time ? formatTimeTo12Hours(service.services[0].start_time) : "-"} 
                    </span>
                  </h6>
                  <h6><b style={{ color: "rgba(103, 120, 95)" }}>Total Amount: </b>{service.total_amount} $</h6>
                  <div className="d-flex justify-content-center">
                    <div style={{ maxHeight: "400px", marginTop: "25px", overflowY: "scroll", margin: "auto" }}>
                      {service.services.map((innerService, innerIndex) => (
                        <Card
                          bg="light"
                          key={innerService.service_id}
                          text="dark"
                          style={{ maxWidth: "22rem", height: "auto", border: "none", borderBottom: "1px solid black", borderRadius: "0px", marginTop: "10px" }}
                          className="mb-2"
                        >
                          <div className="row g-0">
                            <div className="col-md-4 p-3">
                              <CardImg src={`${var_api}/${innerService.image}`} alt="Service image" style={{ borderRadius: "50px" }} />
                            </div>
                            <div className="col-md-8">
                              <CardBody>
                                <CardText>
                                  {/* <h6 style={{color: innerService.type === "cancelled" ? "red" : "blue"}}>
                                    {capitalizeFirstLetter(innerService.type)}
                                  </h6> */}
                                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                                    <h6 style={{ color: innerService.type === "cancelled" ? "red" : "blue", marginRight: '10px' }}>
                                      {capitalizeFirstLetter(innerService.type)}
                                    </h6>
                                    <div style={{ padding: '5px', borderRadius: '15px', backgroundColor: getStatusColor(innerService.service_status) }}>
                                      <h6 style={{ margin: 0, color: 'white' }}>
                                        {getStatusText(innerService.service_status)}
                                      </h6>
                                    </div>
                                  </div>
                                  <h6>{innerService.service_name}</h6>
                                  <h6>{innerService.service_duration} mins</h6>
                                  <ServiceComponent innerService={innerService} />
                                  <h6 className="fw-bolder">${innerService.service_cost}</h6>
                                </CardText>
                              </CardBody>
                            </div>
                          </div>
                        </Card>
                      ))}
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={toggle}>Close</Button>
          </ModalFooter>
        </Modal>
      )}



    <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        size="lg"
      >
        <ModalHeader toggle={() => setIsModalOpen(false)}>
        Edit Customer Details
        </ModalHeader>
        <ModalBody>
          <h6>Phone no: <b style={{color:"red"}}>{updatedCustomer && updatedCustomer.customer_mobile}</b></h6>
          <Form>
            <Form.Group controlId="formCustomerName">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                type="text"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                placeholder="Enter Customer Name"
              />
            </Form.Group>
            <br/>
            {/* <Form.Group controlId="formDob">
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                type="date"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
              />
            </Form.Group> */}
            <Form.Group controlId="formDob">
            <Form.Label>Date of Birth</Form.Label>
            <Form.Control
              type="date"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              placeholder="Enter Date of Birth"
            />
            </Form.Group>
            <br/>
            <Form.Group controlId="formEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}  // OnChange for Email
              placeholder="Enter Email"
            />
            </Form.Group>
            <br/>
            <Form.Group controlId="formGender">
            <Form.Label>Gender</Form.Label>
            <div>
            <Form.Check
              inline
              label="Male"
              type="radio"
              value="Male"
              checked={gender === 'Male'}
              onChange={(e) => setGender(e.target.value)}  // OnChange for Gender
            />
            <Form.Check
              inline
              label="Female"
              type="radio"
              value="Female"
              checked={gender === 'Female'}
              onChange={(e) => setGender(e.target.value)}  // OnChange for Gender
            />
            <Form.Check
              inline
              label="Other"
              type="radio"
              value="Other"
              checked={gender === 'Other'}
              onChange={(e) => setGender(e.target.value)}  // OnChange for Gender
            />
            </div>
            </Form.Group> 
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={() => setIsModalOpen(false)}>
            Close
          </Button>
          <Button color="success" onClick={handleUpdateCustomer}>
            Save Changes
          </Button>
        </ModalFooter>
      </Modal>
        </div>
        </>
    )
}

export default CustomerDetails;

